/* STEP2-NEEDS: Step 2 "needs a selection" indicator (design "option C"), Standard and I9 System builders.
 *  - A small orange "!" badge sits just before the label of every visible, required, unselected row whose buttons can be
 *    clicked (not behind the freehub lock, not set by the System hub, not a tiered row that is not shown yet).
 *  - While required selections are missing, the Next button is aria-disabled (still clickable, never navigates) and says what
 *    is missing: "Choose Freehub Type to continue", "Choose Front Wheel Size and Rear Wheel Size to continue",
 *    "Choose X, Y and N more to continue"; "N selections needed" when the message would not fit on one line (390 px phones).
 *  - Clicking the blocked button scrolls the first missing row into view, flashes it once (not with reduced motion) and
 *    announces the message through an aria-live region.
 *  The missing list mirrors validateStep2's required-selection checks exactly (build type, plus the System hub row); labels
 *  and page order come from the Step 2 DOM. Hooks in assets/variant-builder.js are marked STEP2-NEEDS. No other behaviour of
 *  the Standard builder changes: when validateStep2 says valid, the button is the normal enabled "Next: Components".
 */
(function (global) {
  'use strict';
  var TEXT = { badge: 'Make a selection to continue', next: 'Next: Components' };
  function B() { return global.__loamBuilderInternals || null; }
  function bs() { var b = B(); return b ? b.buildState : null; }
  function step2() { return document.getElementById('step-2'); }
  function nextBtn() { return document.getElementById('step-2-next-button'); }
  function visible(el) { return !!el && el.style.display !== 'none' && (!global.getComputedStyle || getComputedStyle(el).display !== 'none'); }

  // Required rows for this build, mirroring validateStep2 (brake style always; front / rear rows by build type; freehub with a
  // rear wheel) plus the System hub row, which gates every other row of a System build.
  function requiredNames(s) {
    var bT = s.buildType, out = [];
    if (s.spokeInterface === 'system') out.push('systemHub');
    if (bT === 'Front' || bT === 'Wheel Set') out.push('frontWheelSize', 'frontSpokeCount', 'frontHubSpacing');
    if (bT === 'Rear' || bT === 'Wheel Set') out.push('rearWheelSize', 'rearSpokeCount', 'rearHubSpacing', 'freehubType');
    out.push('brakeStyle');
    return out;
  }
  function labelOf(row) { var h = row.querySelector('.selection-label h4'); return h ? h.textContent.replace(/\s+/g, ' ').trim() : row.dataset.specName; }
  // Locked: the row's buttons cannot be clicked yet (freehub "Please make all selections above first" / loading overlay, a row set by the System hub).
  function locked(row) {
    if (row.classList.contains('i9-locked')) return true;
    var ov = row.querySelector('.freehub-lock-overlay');
    return !!(ov && visible(ov));
  }
  function selectable(row) {
    var btns = row.querySelectorAll('.spec-options button.spec-option-button');
    for (var i = 0; i < btns.length; i++) if (visible(btns[i]) && !btns[i].disabled) return true;
    return false;
  }
  // Missing = required, visible, unselected rows in page order (hidden rows are not listed: they cannot be acted on and Step 2
  // shows them once the rows above are done).
  function missing(s) {
    var st = step2(); if (!st || !s || !s.specs || !s.buildType) return [];
    var req = requiredNames(s), out = [];
    var rows = st.querySelectorAll('.spec-group.selection-row[data-spec-name]');
    for (var i = 0; i < rows.length; i++) { var n = rows[i].dataset.specName; if (req.indexOf(n) >= 0 && visible(rows[i]) && !s.specs[n]) out.push(rows[i]); }
    return out;
  }
  function messageFor(labels) {
    if (!labels.length) return TEXT.next;
    if (labels.length === 1) return 'Choose ' + labels[0] + ' to continue';
    if (labels.length === 2) return 'Choose ' + labels[0] + ' and ' + labels[1] + ' to continue';
    return 'Choose ' + labels[0] + ', ' + labels[1] + ' and ' + (labels.length - 2) + ' more to continue';
  }
  function fallbackFor(n) { return n + ' selection' + (n === 1 ? '' : 's') + ' needed'; }

  // The exclamation mark is drawn (rounded bar 3 x 9, a 2.5 gap, a 3.4 dot) so the dot never merges with the bar at small sizes.
  function badgeSvg() { return '<svg viewBox="0 0 22 22" width="22" height="22" aria-hidden="true" focusable="false"><rect x="9.5" y="3.5" width="3" height="9" rx="1.5" fill="#fff"/><circle cx="11" cy="16.7" r="1.7" fill="#fff"/></svg>'; }
  function makeBadge(extraClass, labelled) {
    var b = document.createElement('span'); b.className = 's2-need' + (extraClass ? ' ' + extraClass : '');
    if (labelled) { b.setAttribute('role', 'img'); b.setAttribute('aria-label', TEXT.badge); b.title = TEXT.badge; } else b.setAttribute('aria-hidden', 'true');
    b.innerHTML = badgeSvg();
    return b;
  }
  // Every Step 2 row label gets one fixed-width slot for the badge, right after the (?) help icon (or first, when a row has none),
  // so the labels stay aligned and never jump when a badge appears or disappears. The (?) icon and its tooltip are not touched.
  function slotFor(row) {
    var label = row.querySelector('.selection-label'); if (!label) return null;
    var slot = label.querySelector('.s2-slot');
    if (!slot) {
      slot = document.createElement('span'); slot.className = 's2-slot';
      var help = label.querySelector('.info-tooltip-trigger');
      if (help && help.parentNode === label) label.insertBefore(slot, help.nextSibling); else label.insertBefore(slot, label.firstChild);
    }
    return slot;
  }
  function badgeSync(miss) {
    var st = step2(); if (!st) return;
    var rows = st.querySelectorAll('.spec-group.selection-row[data-spec-name]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i], slot = slotFor(row); if (!slot) continue;
      var badge = slot.querySelector('.s2-need');
      var need = miss.indexOf(row) >= 0 && !locked(row) && selectable(row);
      if (need && !badge) slot.appendChild(makeBadge('', true));
      else if (!need && badge) badge.remove();
    }
  }
  function setText(btn, text, withBadge) {
    btn.innerHTML = '';
    if (withBadge) btn.appendChild(makeBadge('s2-need-btn', false));
    btn.appendChild(document.createTextNode(text));
  }
  // One line only: when the message overflows the button (390 px phones), fall back to "N selections needed".
  function fit(btn, n) { if (btn.scrollWidth > btn.clientWidth + 1) { setText(btn, fallbackFor(n), true); btn.dataset.s2Fallback = '1'; } else delete btn.dataset.s2Fallback; }

  var live = null;
  function announce(text) {
    if (!live) { live = document.createElement('div'); live.id = 's2-need-live'; live.className = 's2-visually-hidden'; live.setAttribute('aria-live', 'polite'); live.setAttribute('aria-atomic', 'true'); document.body.appendChild(live); }
    live.textContent = ''; setTimeout(function () { live.textContent = text; }, 40);
  }

  var lastMessage = '';
  // Called by validateStep2 in place of `step2NextButton.disabled = !isValid`. The classic `disabled` attribute is left to the
  // classic code's own moments (the "Building..." transition, the resets); here the blocked state is aria-disabled + message.
  function applyNext(isValid) {
    var btn = nextBtn(), s = bs(); if (!btn) return;
    var miss = s ? missing(s) : [];
    badgeSync(miss);
    if (isValid) {
      btn.disabled = false; btn.removeAttribute('aria-disabled'); btn.classList.remove('s2-blocked'); delete btn.dataset.s2Fallback;
      if (btn.textContent !== 'Building...') setText(btn, TEXT.next, false);
      lastMessage = '';
      return;
    }
    btn.disabled = false; btn.setAttribute('aria-disabled', 'true'); btn.classList.add('s2-blocked');
    if (miss.length) { lastMessage = messageFor(miss.map(labelOf)); setText(btn, lastMessage, true); fit(btn, miss.length); }
    else { lastMessage = ''; setText(btn, TEXT.next, false); } // disabled for another reason (e.g. a selection with 0 matching parts): classic text, no message
    schedule();
  }
  // Badge-only refresh after the classic code finished its own pass (lock overlay, buttons rendered later, tiered rows revealed).
  var pending = false;
  function refresh() { var s = bs(); if (!s) return; var btn = nextBtn(); var miss = missing(s); badgeSync(miss); if (btn && btn.getAttribute('aria-disabled') === 'true' && miss.length) { var msg = messageFor(miss.map(labelOf)); if (msg !== lastMessage || btn.dataset.s2Fallback) { lastMessage = msg; setText(btn, msg, true); } fit(btn, miss.length); } }
  function schedule() { if (pending) return; pending = true; setTimeout(function () { pending = false; refresh(); }, 0); }
  // sync(): re-run the classic validation (which calls applyNext) when a hook sees the lock state or row visibility change.
  function sync() { var b = B(); if (b && b.fns && typeof b.fns.validateStep2 === 'function') b.fns.validateStep2(); else schedule(); }

  // The blocked button is clickable: show where to go instead of navigating. Capture phase on the document runs before the
  // classic click handler on the button, so showStep(3) is never reached while aria-disabled.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#step-2-next-button') : null;
    if (!btn || btn.getAttribute('aria-disabled') !== 'true') return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var s = bs(); var miss = s ? missing(s) : [];
    if (!miss.length) return;
    var row = miss[0], reduce = !!(global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches);
    try { row.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (err) { row.scrollIntoView(); }
    if (!reduce) { row.classList.remove('s2-flash'); void row.offsetWidth; row.classList.add('s2-flash'); setTimeout(function () { row.classList.remove('s2-flash'); }, 1300); }
    announce(messageFor(miss.map(labelOf)));
  }, true);
  // Width changes (rotation, viewport emulation): re-measure after layout settled, so the full message returns when it fits again.
  var refitTimer = null;
  function refit() { clearTimeout(refitTimer); refitTimer = setTimeout(function () { var btn = nextBtn(); if (btn && btn.getAttribute('aria-disabled') === 'true' && lastMessage) { setText(btn, lastMessage, true); var s = bs(); fit(btn, s ? missing(s).length : 1); } }, 80); }
  if (global.addEventListener) global.addEventListener('resize', refit);
  if (typeof global.ResizeObserver === 'function') { var ro = new global.ResizeObserver(refit), observed = null; setInterval(function () { var btn = nextBtn(); if (btn && btn !== observed) { if (observed) ro.unobserve(observed); ro.observe(btn); observed = btn; } }, 1000); }

  global.Step2Needs = { applyNext: applyNext, sync: sync, refresh: refresh, missing: function () { var s = bs(); return s ? missing(s).map(function (r) { return r.dataset.specName; }) : []; }, messageFor: messageFor, fallbackFor: fallbackFor, requiredNames: requiredNames, badgeSvg: badgeSvg };
})(window);
